import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-task-create-task-api-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class ThirdpartyCreateApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: this.translation.t("specs.createNewThirdParty"),
            description: this.translation.t("specs.createNewThirdPartyDescription"),
            httpMethod: "POST",
            path: "/thirdparty",

            parameters: [
                {
                    name: "Name",
                    description: this.translation.t("parameters.createNewThirdPartyNameDescription"),
                    in: "body",
                    paramType: "string",
                    required: true,
                    example: "third party to create name",
                },
                {
                    name: "Description",
                    description: this.translation.t("parameters.createNewThirdPartyDescriptionDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "third party description",
                },
                {
                    name: "EUMember",
                    description: this.translation.t("parameters.thirdPartyEUMemberDescription"),
                    in: "body",
                    paramType: "boolean",
                    required: false,
                    example: true,
                },
                {
                    name: "LinkedRisks",
                    description: this.translation.t("parameters.thirdPartyLinkedRisksDescription"),
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "LinkedControls",
                    description: this.translation.t("parameters.thirdPartyLinkedControlsDescription"),
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "Address",
                    description: this.translation.t("parameters.thirdPartyAddressDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "1 example drive",
                },
                {
                    name: "ThirdPartyResponsible",
                    description: this.translation.t("parameters.thirdPartyResponsibleDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "Steve Responsible",
                },
                {
                    name: "CocNumber",
                    description: this.translation.t("parameters.thirdPartyCocNumberDescription"),
                    in: "body",
                    paramType: "integer",
                    required: false,
                    example: 1234567890,
                },
                {
                    name: "TaxNumber",
                    description: this.translation.t("parameters.thirdPartyTaxNumberDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "taxnumberforthirdparty123",
                },
                {
                    name: "City",
                    description: this.translation.t("parameters.thirdPartyCityDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "cityofthirdparty",
                },
                {
                    name: "Country",
                    description: this.translation.t("parameters.thirdPartyCountryDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "NL",
                },
                {
                    name: "BeneficialOwner",
                    description: this.translation.t("parameters.thirdPartyBeneficialOwnerDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "Dave Beneficialowner",
                },
                {
                    name: "AuthorizedSignatory",
                    description: this.translation.t("parameters.thirdPartyAuthorizedSignatoryDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "Mark Authorizedsignatory",
                },
                {
                    name: "StatusOfInvolvementId",
                    description: this.translation.t("parameters.thirdPartyStatusOfInvolvementIdDescription"),
                    in: "body",
                    paramType: "integer",
                    required: false,
                    example: 1,
                },
                {
                    name: "Email",
                    description: this.translation.t("parameters.thirdPartyEmailDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "thirdparty@thirdparty.com",
                },
                {
                    name: "Phone",
                    description: this.translation.t("parameters.thirdPartyPhoneDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "0612345678",
                },
                {
                    name: "UserResponsibles",
                    description: this.translation.t("parameters.thirdPartyUserResponsiblesDescription"),
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "Website",
                    description: this.translation.t("parameters.thirdPartyWebsiteDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "www.example.com",
                },
                {
                    name: "Comment",
                    description: this.translation.t("parameters.createNewThirdPartyCommentDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "comment text",
                },
                {
                    name: "LeiCode",
                    description: this.translation.t("parameters.thirdPartyLeiCodeDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "529900T8BM49AURSDO55",
                },
                {
                    name: "DUNS_number",
                    description: this.translation.t("parameters.thirdPartyDUNSNumberDescription"),
                    in: "body",
                    paramType: "long",
                    required: false,
                    example: 1234,
                },
                {
                    name: "OrganizationBeneficialOwner",
                    description: this.translation.t("parameters.thirdPartyOrganizationBeneficialOwnerDescription"),
                    in: "body",
                    paramType: "uuid",
                    required: false,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "OrganizationResponsible",
                    description: this.translation.t("parameters.thirdPartyOrganizationResponsibleDescription"),
                    in: "body",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "EntityRoles",
                    description: this.translation.t("parameters.thirdPartyEntityRolesDescription"),
                    in: "body",
                    paramType: "array of strings",
                    required: false,
                    example: ["DataController", "DataProcessor"],
                },
                {
                    name: "BusinessDimensions",
                    description: this.translation.t("parameters.thirdPartyBusinessDimensionsDescription"),
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "FrameworkDimensions",
                    description: this.translation.t("parameters.thirdPartyFrameworkDimensionsDescription"),
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "Organizations",
                    description: this.translation.t("parameters.createNewThirdPartyOrganizationsDescription"),
                    in: "body",
                    paramType: "array of integers",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "StartDateServicing",
                    description: this.translation.t("parameters.thirdPartyStartDateServicingDescription"),
                    in: "body",
                    paramType: "date",
                    required: false,
                    example: "2025-01-31",
                },
                {
                    name: "EndDateServicing",
                    description: this.translation.t("parameters.thirdPartyEndDateServicingDescription"),
                    in: "body",
                    paramType: "date",
                    required: false,
                    example: "2025-02-28",
                },
                {
                    name: "RelationshipId",
                    description: this.translation.t("parameters.thirdPartyRelationshipIdDescription"),
                    in: "body",
                    paramType: "integer",
                    required: false,
                    example: 1,
                },
                {
                    name: "CriticalityId",
                    description: this.translation.t("parameters.thirdPartyCriticalityIdDescription"),
                    in: "body",
                    paramType: "integer",
                    required: false,
                    example: 1,
                },
                {
                    name: "LinkedServiceIds",
                    description: this.translation.t("parameters.thirdPartyLinkedServiceIdsDescription"),
                    in: "body",
                    paramType: "array of integers",
                    required: false,
                    example: [1, 2],
                },
                {
                    name: "CustomFields",
                    description: this.translation.t("parameters.thirdPartyCustomFieldsDescription"),
                    in: "body",
                    paramType: "array of models",
                    required: false,
                    example: [
                        {
                            CustomFieldGuid: "00000000-0000-0000-0000-000000000000",
                            Value: "1,2",
                        },
                        {
                            CustomFieldGuid: "00000000-0000-0000-0000-000000000001",
                            Value: "1",
                        },
                        {
                            CustomFieldGuid: "00000000-0000-0000-0000-000000000002",
                            Value: "api custom field text",
                        },
                        {
                            CustomFieldGuid: "00000000-0000-0000-0000-000000000004",
                            DateValue: "2025-03-15",
                        },
                    ],
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                    example: "00000000-0000-0000-0000-000000000000",
                },
            ],
        };
    }
}
